import React, { ReactNode } from 'react';
import H4 from './H4';
import Subtitle from './Subtitle';
import { Container } from '../layout';

const Description = ({
  headline,
  description,
  tooltip,
}: {
  headline?: string;
  description?: string;
  tooltip?: ReactNode;
}) => (
  <Container direction="column" alignItems="flex-start" className="descriptionText">
    <H4>{headline}</H4>
    <Subtitle>
      {description} {tooltip}
    </Subtitle>
  </Container>
);

Description.defaultProps = {
  tooltip: '',
  headline: '',
  description: '',
};

export default Description;
